import { type FunctionComponent, lazy, Suspense } from "react";

import { Spinner } from "@app/components/spinners/spinner";

const ImporterCuratePageReviewPlanogramStore = lazy(() => {
  return new Promise<{ default: FunctionComponent }>((resolve, reject) => {
    import("curate/lib")
      .then((lib) => {
        resolve({
          default: () => <lib.default.ReviewStorePlanogramPage />,
        });
      })
      .catch(reject);
  });
});

export const LazyCuratePageReviewPlanogramStore = () => {
  return (
    <Suspense fallback={<Spinner height={"100vh"} />}>
      <ImporterCuratePageReviewPlanogramStore />
    </Suspense>
  );
};
